module.exports = "@font-face {\n  font-family: Poppins;\n  src: url(\"/assets/Poppins/Poppins-Medium.ttf\");\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/assets/poppins.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/assets/poppins.css
// module chunks = styles